import { Box, Link, Stack, styled } from "@mui/material";
import { BodyTextM } from "../Typography";

export const PersonDetailHeader = styled(BodyTextM)(({ theme }) => ({
    fontWeight: theme.typography.fontWeightBold,
}));

export const PersonDetailChangeLink = styled(Link)(({ theme }) => ({
    textDecoration: "none",
    color: theme.palette.primary.main,
}));

export const PersonDetailWrapperStack = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        px: { xs: 3, md: 4 },
        py: 6,
        flex: "1 1 0px",
    }),
);

export const PersonDetailHeaderStack = styled(Stack)(({ theme }) => ({
    flexDirection: "row",
    justifyContent: "space-between",
}));

export const PersonDetailBodyBox = styled(Box)(({ theme }) =>
    theme.unstable_sx({
        p: theme.spacing(0),
        pt: theme.spacing(2),
    }),
);
